import { ascend, head, pathOr, pipe, prop, sort } from 'ramda';
import { createSelector } from 'reselect';

export const selectFirstSportSorted = (serviceId) =>
  createSelector(
    pathOr([], ['sports', serviceId]),
    pipe(sort(ascend(prop('sportWeight'))), head)
  );
